/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SequenceStepResponseType = typeof SequenceStepResponseType[keyof typeof SequenceStepResponseType];


export const SequenceStepResponseType = {
  automatic_email: 'automatic_email',
  manual_email: 'manual_email',
  phone_call: 'phone_call',
  text_message: 'text_message',
  custom_task: 'custom_task',
  linkedin_profile_view: 'linkedin_profile_view',
  linkedin_connection_request: 'linkedin_connection_request',
  linkedin_message: 'linkedin_message',
} as const;
